import React, { useState } from 'react';
import { useFormik } from 'formik';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import {createRequest} from '../request/list/core/_requests';

const CreateRequest = () => {
    const navigate = useNavigate();
     const location = useLocation();
    const jsonData = location.state.jsonData; // JSON verisini location state'den al
    console.log(jsonData);
    const formik = useFormik({
        initialValues: {
            name: '',
            lastDateWriter: '',
            lastDateReviewer: '',
            lastDate: '',
            invoiceNumber: '',
            invoiceDate: ''
        },
        onSubmit: async (values) => {
            try {
                // API ile veritabanına kaydetme işlemi
                createRequest(values).then((a:any) => {
                    console.log(a);
                    //console.log(response);
                    const requestId = a.id; // API'den dönen request ID
                    console.log(requestId);
                    navigate('/create-packages', { state: { requestId, jsonData } });
                });

                //alert('Kayıt başarılı!');
                //navigate('/create-packages'); // Başarıyla kayıttan sonra ana sayfaya yönlendir
            } catch (error) {
                console.error('Kayıt sırasında bir hata oluştu', error);
                alert('Kayıt sırasında bir hata oluştu.');
            }
        }
    });

    return (
        <div className='container'>
            <form onSubmit={formik.handleSubmit}>
                <h1>Yeni Talep Oluştur</h1>
                <label htmlFor='name'>Adı:</label>
                <input
                    id='name'
                    name='name'
                    type='text'
                    onChange={formik.handleChange}
                    value={formik.values.name}
                />

                <label htmlFor='lastDateWriter'>Son Yazım Tarihi:</label>
                <input
                    id='lastDateWriter'
                    name='lastDateWriter'
                    type='datetime-local'
                    onChange={formik.handleChange}
                    value={formik.values.lastDateWriter}
                />

                <label htmlFor='lastDateReviewer'>Son Kontrol Tarihi:</label>
                <input
                    id='lastDateReviewer'
                    name='lastDateReviewer'
                    type='datetime-local'
                    onChange={formik.handleChange}
                    value={formik.values.lastDateReviewer}
                />

                <label htmlFor='lastDate'>Son Teslim Tarihi:</label>
                <input
                    id='lastDate'
                    name='lastDate'
                    type='datetime-local'
                    onChange={formik.handleChange}
                    value={formik.values.lastDate}
                />

                <button type='submit'>Kaydet</button>
            </form>
        </div>
    );
}

export default CreateRequest;
